import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The top bar (design-spec §3, §4 "Top bar + tabs"): 60px on `--ground`, padding 0 40, gap 40;
 * the wordmark 20/700, tabs with gap 28, the end slot pushed right. A tab rests ink-2/500 and
 * hovers ink-1 (`--tab-ink`, the `[data-tab]` rule in `interactions.css`); the current one is
 * ink-1/600 with a 2px accent bar 12 above the bottom and `aria-current="page"`. You-are-here
 * is never accent text: only the bar is lavender (§5). With no tabs there is no `<nav>` at all,
 * since an empty landmark is wrong (the Connections page, epic 26-10-27-person-files-voice
 * design-spec §8 W3).
 */
export function TopBar({ wordmark, tabs, current, end }) {
    return (_jsxs("header", { "data-top-bar": "", style: {
            position: "relative", zIndex: 3, flex: "none", height: 60,
            display: "flex", alignItems: "stretch", gap: "var(--space-5)",
            padding: "0 var(--space-5)", background: "var(--ground)",
        }, children: [_jsx("span", { "data-wordmark": "", style: {
                    display: "flex", alignItems: "center", whiteSpace: "nowrap", color: "var(--ink-1)",
                    fontFamily: "var(--font-sans)", fontSize: "var(--type-wordmark-size)",
                    fontWeight: "var(--type-wordmark-weight)", letterSpacing: "var(--type-wordmark-tracking)",
                }, children: wordmark }), tabs.length > 0 && (_jsx("nav", { "aria-label": "Main", style: { display: "flex", alignItems: "stretch", gap: "var(--space-35)" }, children: tabs.map((tab) => {
                    const here = tab.id === current;
                    return (_jsxs("a", { href: tab.href, "data-tab": here ? "current" : "", "data-nav-tab": tab.id, "aria-current": here ? "page" : undefined, onClick: (event) => {
                            // A modified click opens a new tab as a link does; a plain one routes in place.
                            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
                                return;
                            event.preventDefault();
                            tab.onSelect();
                        }, style: {
                            position: "relative", display: "flex", alignItems: "center", whiteSpace: "nowrap",
                            textDecoration: "none", fontFamily: "var(--font-sans)",
                            fontSize: "var(--type-body-size)", lineHeight: "var(--type-body-line)",
                            fontWeight: here ? "var(--type-body-weight-current)" : "var(--type-body-weight-strong)",
                            color: here ? "var(--ink-1)" : "var(--tab-ink, var(--ink-2))",
                            transition: "color var(--dur-fast) var(--ease-out)",
                        }, children: [tab.label, here && (_jsx("span", { "data-tab-bar": "", "aria-hidden": "true", style: {
                                    position: "absolute", left: 0, right: 0, bottom: "var(--space-15)",
                                    height: "var(--border-indicator)", background: "var(--accent)",
                                    borderRadius: "var(--radius-bar)",
                                } }))] }, tab.id));
                }) })), end !== undefined && _jsx("div", { style: { marginLeft: "auto", display: "flex", alignItems: "center" }, children: end })] }));
}
